import { nioJsBridge,storage } from "@nio-wad/universal-bridge-h5";
import { isEmptyObj } from "./tools";
import { PAD_APPID, LAST_BIND_USER_STORAGE } from "./Constant";
export const isLg = navigator.userAgent.includes("lg _dsbridge");
export const isCNLg = isLg && /SalesPadCN/i.test(navigator.userAgent);
export const isApp = isLg && isCNLg;

let currentSubToken = null

export const getAppStatusBarHeight = async () => {
  if (!isApp) return 0;
  const osInfo = await nioJsBridge.getOSInfo();
  const statusBarPixels = Number(osInfo.data.safeAreaInsets.top);
  return statusBarPixels || 24;
};

export const getUserInfo = () => {
  if (!isApp) return '';
  let userInfo = dsBridge.call("getUserInfo", "");
  if (userInfo?.result_code == "success") {
    return userInfo.data;
  }
  return "";
};
export const getFellowName = () => {
  if (!isApp) return "";
  let userInfo = getUserInfo();
  return (userInfo && userInfo?.user_name) || "";
};
export const getFellowUserId = () => {
  if (!isApp) return "";
  let userInfo = getUserInfo();
  return (userInfo && (userInfo?.user_id || userInfo?.user_name)) || "";
};
export const getSubToken = (app_id = PAD_APPID) => {
  if(app_id !== PAD_APPID || !isApp) return false
  return new Promise((resolve, reject) => {
    if(currentSubToken){
      const currentDate = new Date().getTime()
      if(currentDate - currentSubToken.expires_at * 1000 > 1000 * 60 * 60 * 24){
        return resolve(currentSubToken.access_token)
      }
    }
    dsBridge.call("getSubToken", { child_app_id: app_id }, (result) => {
      console.log('result>>>>',app_id,result)
      if (result?.result_code == "success" && result.data) {
        currentSubToken = result.data
        resolve(result.data.access_token);
      } else {
        resolve(false)
      }
    })
  })
}
// 展开收缩右侧栏
export const toggleSideMenu = async () => {
  if (!isApp) return;
  dsBridge.call("toggleSideMenu");
};

export const showToast = async (content) => {
  if(!isApp) return
  await nioJsBridge.showToast({
    data: {
      content: content,
    },
  });
};
export const showLoading = async (content = '') => {
  if(!isApp) return
  await nioJsBridge.showLoading({
    data: {
      content: content,
    },
  });
}
export const hideLoading = async () => {
  if(!isApp) return
  await nioJsBridge.hideLoading();
}
// APP进入前台
export const appearApp = () => {
  nioJsBridge.register({
    event: "ON_APPEAR",
    data: {
      preventDefault: 0,
    },
    callback: (e) => {
      console.log("---收到进入前台的事件--e---", e);
    },
  });
};
// 存储数据
export const setStorageApp = (key,value) =>{
  if(!isApp) return
  storage.set({
        data:{
            key,
            value
        }
    })
}
// 读取数据
export const getStorageApp =  (key) =>{
  if(!isApp) return
  let result =  storage.get({
        data:{
            key
        }
    })
  if(result?.result_code == 'success'){
    return result.data?.value || null
  }
  return null
}
// 删除数据
export const removeStorageApp = (key) =>{
  if(!isApp) return
  storage.remove({
        data:{
            key
        }
    })
}

/** 设置上次绑定的用户信息 */
export const setLastUserInfo = (userInfo) => {
  const fellowId = getFellowUserId()

  setStorageApp(`${LAST_BIND_USER_STORAGE}_${fellowId}`, JSON.stringify(userInfo))
}

/** 获取上次绑定的用户信息 */
export const getLastUserInfo = () => {
  const fellowId = getFellowUserId()
  const value = getStorageApp(`${LAST_BIND_USER_STORAGE}_${fellowId}`)

  try {
    console.info('last bind user', value)
    return JSON.parse(value)
  } catch (error) {
    return null
  }
}

// pad端H5获取用户信息jsbridge
export const getUserInfoByPad = (mobile,areaCode) => {
  if(!isApp || !mobile || !areaCode) return
  return new Promise((resolve, reject) => {
    dsBridge.call("getNioUserInfo", {mobile:mobile,areaCode:areaCode}, (result) => {
      console.log('---pad端H5获取用户信息jsbridge---',result);
      if(result.result_code === 'success'){
        if(result.data && !isEmptyObj(result.data)) return resolve(result.data)
        resolve(null)
      }else{
        return reject('网络错误，请稍后再试')
      }
    });
  })
}
// pad端 H5用户信息绑定jsbridge
export const bindNioUserInfo = (userInfo) => {
  if(!isApp) return
  let result = dsBridge.call("bindNioUserInfo", {userInfo:userInfo})
  if(result.result_code == 'success') {
    setLastUserInfo(userInfo)
    return true
  }
  return false
}
// pad端 H5获取绑定用户信息jsbridge
export const getNioBindedUserInfo = () => {
  if(!isApp) return false
  let result = dsBridge.call("getNioBindedUserInfo")
  if(result.result_code == 'success' && result.data && !isEmptyObj(result.data)) return result.data
  return null
}
// pad端 H5解绑用户信息jsbridge
export const unbindNioUserInfo = () => {
  if(!isApp) return
  let result = dsBridge.call("unbindNioUserInfo")
  console.log('---unbindNioUserInfo---',result);
  if(result.result_code == 'success') return true
  return false
}

/**
 * 监听键盘事件
 */
export const listenKeyboard = (callback) => {
  if(!isApp) return
    dsBridge.register("ON_KEYBOARD_STATE_CHANGE", (result) => {
      console.log('---监听键盘事件---',result);
      if(result.result_code == 'success') return callback(result.data.isShowKeyBoard)
      return false
    });

}

/**
 *
 * @returns 获取当前登录FL的归属门店信息
 * {"result_code": "success",
 *  "data": {"belong_msgs":[
 *   {"nio_house_district": "Europe Region"},
 *   {"nio_house_district": "上海公司",
 *    "nio_house_city": "上海市"}]
 * }}
 *
 * 门店code:niohouse_id
   门店名称:niohouse_name
   归属城市:niohouse_city
   归属区域:niohouse_district
 */
export const getShopInfo = ()=>{
  if(!isApp) return
  let result = dsBridge.call('getShopInfo');
  console.log('---getShopInfo---',result)
  if(result.result_code == 'success') {
    return result?.data?.belong_msgs || ''
  }
}



export const isTpad =  isApp;
